var angular = require('angular');
var _module = require('./index');

_module
    .factory('$utils', ['$q', '$http', function($q, $http) {
        return {
            isImage: function(url) {
                var defer = $q.defer();
                var image = new Image();

                image.onerror = function() {
                    defer.reject();
                };

                image.onload = function() {
                    defer.resolve();
                };

                image.src = url;

                return defer.promise;
            },

            hasTouchSupprt: function() {
                return ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch;
            },

            sendEmail: function (to, subject, body) {
                var API_URL  = "https://www.listreports.com";
                var defer    = $q.defer();
                var endpoint = API_URL + '/v1/send-email/generic';
                var payload  = {
                    to      : to,
                    subject : subject,
                    body    : body
                };

                $http
                    .post(endpoint, payload)
                    .success(function (response) {
                        console.log('Email Sent: ', response);
                        defer.resolve();
                    })
                    .error(function (err){
                        console.log('Email Error: ', err);
                        defer.reject(err);
                    });

                return defer.promise;
            }
        };
    }])
;